import React, { useEffect } from 'react';
import {
  ProfileDataItem,
  AddValue,
} from 'pages/Profile/components/ProfileDataItem/ProfileDataItem';
import Label from 'components/form/Label/Label';
import useDirtyData from 'pages/Profile/pages/ProfileOverview/hooks/useDirtyData';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { maskPhoneNumber } from 'helpers/userHelper';
import { useDispatch } from 'react-redux';
import { requireTwoFactorAuthentication } from 'actions/twofactor.actions';
import { useHistory } from 'react-router-dom';
import { SET_TWO_FACTOR_STEP } from 'types/twofactors.constants';
import { UPDATE_PHONE } from 'partial/TwoFactorModal/TwoFactorsView.constants';

export const PhoneNumber = ({
  contactPhoneNumber,
  phoneNumberInput,
  saveData,
  showUnMaskedPhoneNumber,
  quitTwo2faOauth,
  initializePhoneOnForm,
  overWriteTitle,
  hideTitle,
  fullWidth,
  ...props
}) => {
  const maskedPhoneNumber = maskPhoneNumber(showUnMaskedPhoneNumber || '');
  const contactPhoneNumberDisplay = !showUnMaskedPhoneNumber
    ? maskedPhoneNumber
    : phoneNumberInput.contactPhoneNumber.displayValue;

  const editEnabled =
    phoneNumberInput.contactPhoneNumber &&
    !props.readOnly &&
    !props?.isTestUser;

  const dirtyData = useDirtyData({});
  const history = useHistory();

  useEffect(() => {
    if (contactPhoneNumber) {
      onChangePhoneNumber({ target: { value: contactPhoneNumber } });
    }
    // eslint-disable-next-line
  }, [contactPhoneNumber]);

  const dispatch = useDispatch();
  const add2FA = f => v => {
    dispatch(
      requireTwoFactorAuthentication(history, history.location, {
        requireEnrollment: true,
      }),
    ).then(_ => {
      f(v);
    });
  };
  const onChangeEdit = !quitTwo2faOauth ? add2FA(onSaveHandle) : onSaveHandle;

  const { Title, DisplayView } = ProfileDataItem;

  function onChangePhoneNumber(e) {
    const { value } = e.target;
    if (!/^[0-9-()_ ]*$/.test(value)) {
      return false;
    } else {
      phoneNumberInput.update(value);

      dirtyData.processDirtyData(
        'contactPhoneNumber',
        phoneNumberInput.trimPhoneNumberUS(value),
        contactPhoneNumber,
      );
    }
  }

  function onEditHandle(e) {
    e.preventDefault();
    props.eventHandler(CLICK, { 'Click Type': 'Edit Phone Number' });
    onChangeEdit(e);
  }

  function onSaveHandle(e) {
    e.preventDefault();
    props.eventHandler(CLICK, { 'Click Type': 'Save Phone Number Update' });
    dispatch({
      type: SET_TWO_FACTOR_STEP,
      step: UPDATE_PHONE,
    });
    history.push('/profile/personalInfo/2fa');
  }

  let profileDataItemClass = props.classNameOverwrites?.profileDataItem;
  let titleLabel = overWriteTitle ? overWriteTitle : 'Phone number';

  return (
    <ProfileDataItem
      datatestid="phoneNumber"
      classNameOverwrites={profileDataItemClass?.profileDataItem}
    >
      {!hideTitle && (
        <Title
          datatestid="phoneNumberLabel"
          labelType={profileDataItemClass?.title}
        >
          {titleLabel}
        </Title>
      )}
      <DisplayView
        editHandle={onEditHandle}
        editEnabled={editEnabled}
        classNameOverwrites={props.classNameOverwrites?.displayView}
      >
        {contactPhoneNumberDisplay && (
          <Label className="text-16">{contactPhoneNumberDisplay}</Label>
        )}
        {!contactPhoneNumber && (
          <AddValue label="phone number" setIsEdit={onChangeEdit} />
        )}
      </DisplayView>
    </ProfileDataItem>
  );
};
